export default __webpack_public_path__ + "static/media/user-add.4a6645dd.png";